"use client";

import { c as _c } from "react/compiler-runtime";
import { LoadingModal } from "@/components/LoadingModal";
import { AuditRunning } from "@/components/view/AuditRunning";
import { AuditError } from "@/components/view/AuditError";
import { NewAudit } from "@/components/view/NewAudit";
import { AuditState } from "@/types/epc-interfaces";
import { useEllimae } from "@/store/useEllimae";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
export default function Home() {
  const $ = _c(9);
  const ellimaeState = useEllimae(_temp);
  const router = useRouter();
  const auditState = ellimaeState.originResponse?.auditDetail?.auditState;
  let t0;
  let t1;
  if ($[0] !== auditState || $[1] !== router) {
    t0 = () => {
      if (auditState === AuditState.Complete) {
        router.replace("/audit");
      }
    };
    t1 = [auditState, router];
    $[0] = auditState;
    $[1] = router;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  if (ellimaeState.loading) {
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <LoadingModal title="Loading..." size="large" />;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  if (auditState === AuditState.Processing || auditState === AuditState.Error) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <AuditRunning />;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  if (auditState === AuditState.Failed) {
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <AuditError />;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  let t2;
  if ($[7] !== auditState) {
    t2 = auditState !== AuditState.Complete && <NewAudit />;
    $[7] = auditState;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp(state) {
  return state;
}